module.exports = __webpack_public_path__ + "img/up-cultura-scoala.8586422f.png";